<p-confirmPopup></p-confirmPopup>
<custom-table [config]="customTable">
</custom-table>
<section>
	<form [formGroup]="usuarioForm" (submit)="onSubmit()">

		<p-dialog [(visible)]="displayModal" [modal]="true" [autoZIndex]="true" [draggable]="false"
			[resizable]="true" [maximizable]="true"  
			[breakpoints]="{'960px': '100vw'}" [style]="{width: '70vw'}" >

			<ng-template pTemplate="header">
				<CustomTitle [title]="formTitle" />
			</ng-template>

			<ng-template pTemplate="content">
				<main class="grid formgrid p-fluid">
					<div class="field col-12 md:col-6">
						<label class="ml-3" for="nombre">Nombre<span style="color: red">*</span></label>
						<input pInputText formControlName="nombre" id="nombre" type="text"/>
						<ng-container *ngIf="usuarioForm.get('nombre')?.invalid && usuarioForm.get('nombre')?.touched">
							<app-form-group-error-message [control]="usuarioForm.get('nombre')"></app-form-group-error-message>
						</ng-container>
					</div>
					<div class="field col-12 md:col-6">
						<label class="ml-3" for="apellido">Apellido<span style="color: red">*</span></label>
						<input pInputText formControlName="apellido" id="apellido" type="text"/>
						<ng-container *ngIf="usuarioForm.get('apellido')?.invalid && usuarioForm.get('apellido')?.touched">
							<app-form-group-error-message [control]="usuarioForm.get('apellido')"></app-form-group-error-message>
						</ng-container>
					</div>
					<div class="field col-12 md:col-6">
						<label class="label-form-sidebar" for="tipoIdentificacionId">Tipo Identificacion<span
								style="color: red">*</span></label>
						<p-dropdown [options]="tipoIdentificaciones" formControlName="tipoIdentificacionId" appendTo="body" class="border-blue"
							placeholder="Tipo Identificacio" optionLabel="descripcion" optionValue="id" autoWidth="false" [style]="{'width':'100%'}">
						</p-dropdown>
						<ng-container *ngIf="usuarioForm.get('tipoIdentificacionId')?.invalid && usuarioForm.get('tipoIdentificacionId')?.dirty">
							<app-form-group-error-message [control]="usuarioForm.get('tipoIdentificacionId')"></app-form-group-error-message>
						</ng-container>
					</div>
					<div class="field col-12 md:col-6">
						<label class="label-form-sidebar" for="identificacion">Identificacion<span
								style="color: red">*</span></label>
						<p-inputNumber formControlName="identificacion" id="identificacion" inputStyleClass="w-full" styleClass="w-full"
							class="w-full" [useGrouping]="false"></p-inputNumber>
						<ng-container *ngIf="usuarioForm.get('identificacion')?.invalid && usuarioForm.get('identificacion')?.touched">
							<app-form-group-error-message [control]="usuarioForm.get('identificacion')"></app-form-group-error-message>
						</ng-container>
					</div>
					<div class="field col-12 md:col-6">
						<label class="label-form-sidebar" for="correo">Correo<span
								style="color: red">*</span></label>
						<input pInputText formControlName="correo" id="correo" type="text" class="border-blue w-full" />
						<ng-container *ngIf="usuarioForm.get('correo')?.invalid && usuarioForm.get('correo')?.touched">
							<app-form-group-error-message [control]="usuarioForm.get('correo')"></app-form-group-error-message>
						</ng-container>
					</div>
					<div class="field col-12 md:col-6">
						<label class="ml-3" for="cargoId">Cargo<span style="color: red">*</span></label>
						<p-dropdown [options]="cargos" formControlName="cargoId" appendTo="body" placeholder="Select"
							optionLabel="codificacion" optionValue="id" autoWidth="false" [style]="{'width':'100%'}">
						</p-dropdown>
						<ng-container *ngIf="usuarioForm.get('cargoId')?.invalid && usuarioForm.get('cargoId')?.dirty">
							<app-form-group-error-message [control]="usuarioForm.get('cargoId')"></app-form-group-error-message>
						</ng-container>
					</div>
					<div class="field col-12 md:col-6">
						<label class="ml-3" for="dependenciaIds">Dependencias<span style="color: red">*</span></label>
						<p-multiSelect [options]="dependencias" formControlName="dependenciaIds" appendTo="body"
						optionLabel="descripcion" optionValue="id" autoWidth="false" [style]="{'width':'100%'}" placeholder="Dependencias"/>						
						<ng-container *ngIf="usuarioForm.get('dependenciaIds')?.invalid && usuarioForm.get('dependenciaIds')?.dirty">
							<app-form-group-error-message [control]="usuarioForm.get('dependenciaIds')"></app-form-group-error-message>
						</ng-container>
					</div>
				</main>
			</ng-template>
			<ng-template pTemplate="footer">
				<div class="field col-12">
					<div class="flex justify-content-between">
						<button pButton type="button" [label]="'form.button.limpiar' | translate" iconPos="right" icon="pi pi-eraser" class="tax-app-button"
							style="width: 16rem;" (click)="resetForm()"></button>
						<button pButton type="submit" [label]="'form.button.guardar' | translate" icon="pi pi-save" iconPos="right" class="tax-app-button"
							style="width: 16rem;" [disabled]="!ls.hasRole(role.ADMIN_SEC)"></button>
					</div>
				</div>
			</ng-template>
		</p-dialog>

	</form>
</section>